import React from 'react';
import Header from './Header';
import Footer from './Footer';

const ContentLayout = ({ eyebrow, titleTop, titleItalic, intro, testid, children }) => (
  <div className="App" data-testid={testid}>
    <Header />
    <main className="bg-cream">
      <section className="max-w-[1100px] mx-auto px-6 lg:px-10 pt-16 pb-4 text-center">
        {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-burgundy leading-tight">
          {titleTop} {titleItalic && <span className="font-italic-display text-rose-italic">{titleItalic}</span>}
        </h1>
        {intro && <p className="mt-6 text-mahogany/80 text-base md:text-lg max-w-3xl mx-auto leading-relaxed">{intro}</p>}
      </section>
      <section className="max-w-[1000px] mx-auto px-6 lg:px-10 pb-20">{children}</section>
    </main>
    <Footer />
  </div>
);

export const Eyebrow = ({ children }) => <div className="eyebrow mb-2">{children}</div>;

export const H2 = ({ top, italic }) => (
  <h2 className="font-serif-display text-3xl md:text-4xl text-burgundy mb-4">
    {top} {italic && <span className="font-italic-display text-rose-italic">{italic}</span>}
  </h2>
);

export const Prose = ({ children }) => (
  <div className="space-y-4 text-burgundy/85 leading-relaxed text-[15px] md:text-base">{children}</div>
);

export default ContentLayout;
